import React from 'react';
import { View, Center, VStack } from 'native-base';
import useMediaQuery from '@mui/material/useMediaQuery';

// Assets
import { theme } from '@breakroom-nx/assets';
import logoImage from '../../../../assets/src/images/logo.webp';
import errorImage from '../../../../assets/src/images/404.gif';

export function PageNotFound() {
  const mobileDevice = useMediaQuery('(max-width:600px)');

  return (
    <View
      height={'full'}
      width={'full'}
      bg={theme.colors.surface[100]}
      style={{
        overflow: 'hidden',
      }}
    >
      <Center margin={'auto'}>
        <VStack alignItems={'center'} space={0}>
          <img
            src={logoImage}
            alt={`${AppData.APP_NAME} logo`}
            height={mobileDevice ? 20 : 50}
          />
          <img
            src={errorImage}
            alt={'404'}
            style={{
              width: `${mobileDevice ? '50%' : 'full'}`,
            }}
          />
        </VStack>
      </Center>
    </View>
  );
}

export default React.memo(PageNotFound);
